import { renderSlot as _renderSlot, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = ["id", "name", "value"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _directive_prohibit_zoom = _resolveDirective("prohibit-zoom")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'pb-x6': _ctx.showErrors })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Field, {
        modelValue: _ctx.internalValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
        name: _ctx.name,
        value: _ctx.value,
        rules: _ctx.fieldRules,
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocused = false)),
        onInput: _ctx.handleChange
      }, {
        default: _withCtx(({ field, errorMessage }) => [
          _withDirectives((_openBlock(), _createElementBlock("select", _mergeProps({
            id: _ctx.fieldId,
            class: { 'c-select--highlighted': _ctx.highlighted, 'border-roman': !!errorMessage },
            name: _ctx.name,
            value: _ctx.value
          }, { ..._ctx.fieldAttrs, ...field }, { class: "c-select border-silver focus:border-black w-full z-0 mt-7 pr-20" }), [
            _renderSlot(_ctx.$slots, "default")
          ], 16, _hoisted_2)), [
            [_directive_prohibit_zoom]
          ]),
          _createVNode(_Transition, { name: "o-anim-fade-300" }, {
            default: _withCtx(() => [
              (_ctx.label && (_ctx.internalValue !== undefined || _ctx.internalValue !== '' || _ctx.fieldInternalValue !== undefined || _ctx.fieldInternalValue !== ''))
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    for: _ctx.fieldId,
                    class: _normalizeClass({
                               'c-input__label c-select__label--has-value': !_ctx.highlighted,
                               'c-select--highlighted__label c-select--highlighted__label--has-value': _ctx.highlighted
                           })
                  }, _toDisplayString(_ctx.label), 11, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.isFocused)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.fieldId,
                class: _normalizeClass(["c-input-magic-line", { 'bg-roman': !!errorMessage }])
              }, null, 10, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["modelValue", "name", "value", "rules", "onInput"]),
      (_ctx.showErrors)
        ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
            key: 0,
            name: _ctx.name,
            class: "c-input__errors"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}